import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import { storage } from 'src/utilities/Storage';
import { LAST_UPDATED_LS_KEY } from '../constants';
import { ACTION_TYPES, DeveloperOptionState } from './types';

const initialState: DeveloperOptionState = {
  apiContentEncryption: {
    active: false,
    lastUpdated: storage.get(LAST_UPDATED_LS_KEY, null),
    status: 'idle',
    key: '',
  },
  callbackUrl: {
    data: [],
    status: 'idle',
    formErrors: {},
  },
  redirectUrl: {
    data: [],
    status: 'idle',
    formErrors: {},
  },
};

export default function developerOptionsReducer(
  state = initialState,
  action: ActionType = defaultAction,
): DeveloperOptionState {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION:
      return update(state, {
        apiContentEncryption: {
          $merge: {
            status: 'loading',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION_SUCCESS:
      return update(state, {
        apiContentEncryption: {
          $merge: {
            active: payload.data.active,
            key: payload.data.key,
            status: 'success',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_API_CONTENT_ENCRYPTION_FAILED:
      return update(state, {
        apiContentEncryption: {
          $merge: {
            status: 'error',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_CALLBACK_URL:
      return update(state, {
        callbackUrl: {
          $merge: {
            status: 'loading',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_CALLBACK_URL_SUCCESS:
      return update(state, {
        callbackUrl: {
          $merge: {
            data: payload.data?.data,
            status: 'success',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_CALLBACK_URL_FAILED:
      return update(state, {
        callbackUrl: {
          $merge: {
            status: 'error',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_SET_CALLBACK_URL:
      return update(state, {
        callbackUrl: {
          $merge: {
            data: state.callbackUrl.data.map(item =>
              item.service === payload.service ? payload : item,
            ),
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_SET_CALLBACK_URL_ERROR:
      return update(state, {
        callbackUrl: {
          formErrors: {
            $merge: {
              [payload.service]: payload.error,
            },
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_REDIRECT_URL:
      return update(state, {
        redirectUrl: {
          $merge: {
            status: 'loading',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_REDIRECT_URL_SUCCESS:
      return update(state, {
        redirectUrl: {
          $merge: {
            data: payload.data?.data,
            status: 'success',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_GET_REDIRECT_URL_FAILED:
      return update(state, {
        redirectUrl: {
          $merge: {
            status: 'error',
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_SET_REDIRECT_URL:
      return update(state, {
        redirectUrl: {
          $merge: {
            data: state.redirectUrl.data.map(item =>
              item.service === payload.service ? payload : item,
            ),
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_SET_REDIRECT_URL_ERROR:
      return update(state, {
        redirectUrl: {
          formErrors: {
            $merge: {
              [payload.service]: payload.error,
            },
          },
        },
      });
    case ACTION_TYPES.DEVELOPER_OPTION_API_CONTENT_ENCRYPTION_SET_STATUS:
      return update(state, {
        apiContentEncryption: {
          status: {
            $set: payload,
          },
        },
      });
    default:
      return state;
  }
}
